import { useEffect } from "react";
import { useChat } from "@/context/ChatContext";
import { useState } from "react";

const BASE_TITLE = "DreamCRM - Dreamtime Resorts";

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function setFavicon(alert) {
  const c = document.createElement("canvas");
  c.width = 64; c.height = 64;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#0284c7";
  roundRect(ctx, 2, 2, 60, 60, 16);
  ctx.fill();
  ctx.fillStyle = "#ffffff";
  ctx.font = "bold 42px Arial, sans-serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("D", 32, 35);
  if (alert) {
    ctx.beginPath();
    ctx.arc(50, 15, 13, 0, 2 * Math.PI);
    ctx.fillStyle = "#ef4444";
    ctx.fill();
    ctx.lineWidth = 4;
    ctx.strokeStyle = "#ffffff";
    ctx.stroke();
  }
  let link = document.querySelector("link[rel~='icon']");
  if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
  link.href = c.toDataURL("image/png");
}

export function TabAlerts() {
  const { unread } = useChat();
  const [notif, setNotif] = useState(0);

  useEffect(() => {
    const on = (e) => setNotif(e.detail || 0);
    window.addEventListener("notif-unread", on);
    return () => window.removeEventListener("notif-unread", on);
  }, []);

  const total = (unread?.total || 0) + notif;

  useEffect(() => {
    document.title = total > 0 ? `(${total}) ${BASE_TITLE}` : BASE_TITLE;
    setFavicon(total > 0);
  }, [total]);

  return null;
}
